module.exports = __webpack_public_path__ + "static/media/familytvnetwork_circle.eac7cd7b.png";